import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

function ModalAdd({
  args,
  isOpen,
  toggle,
  close,
  onChange,
  onKeyUp,
  onClick,
  error,
}) {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const togglePassword2 = () => {
    setPasswordShown2(!passwordShown2);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} {...args}>
      <ModalHeader toggle={toggle} close={close}>
        <span className="t-primary fs-4 fw-bold">Add</span>
      </ModalHeader>
      <ModalBody className="px-4">
        <div className="w-100">
          <div className="d-flex w-100">
            <div className="w-50 me-2">
              <div>
                <Label className="mb-2">Last Name</Label>
                <Input
                  className="fs-6 border_input rounded w-100"
                  type="text"
                  name="lastname"
                  onChange={onChange}
                  onKeyUp={onKeyUp}
                />
              </div>

              {error.lastname && <p className="error">{error.lastname}</p>}
            </div>

            <div className="w-50 ms-2">
              <div>
                <Label className="mb-2">First Name</Label>
                <Input
                  className="fs-6 border_input rounded w-100"
                  type="text"
                  name="firstname"
                  onChange={onChange}
                  onKeyUp={onKeyUp}
                />
              </div>

              {error.firstname && <p className="error">{error.firstname}</p>}
            </div>
          </div>

          <div className="mt-2">
            <Label className="mb-2">Phone</Label>
            <Input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="phone"
              onChange={onChange}
              onKeyUp={onKeyUp}
            />
          </div>

          {error.phone && <p className="error">{error.phone}</p>}

          <div className="mt-2">
            <Label className="mb-2">Email</Label>
            <Input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="email"
              onChange={onChange}
              onKeyUp={onKeyUp}
            />
          </div>

          {error.email && <p className="error">{error.email}</p>}

          <div className="mt-2">
            <Label className="mb-2">Username</Label>
            <Input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="username"
              onChange={onChange}
              onKeyUp={onKeyUp}
            />
          </div>

          {error.username && <p className="error">{error.username}</p>}

          <div className="mt-2">
            <Label className="mb-2">Password</Label>
            <div className="border_input rounded w-100 d-flex align-items-center">
              <Input
                className="fs-6 border-0 w-100 aaa"
                type={passwordShown ? "text" : "password"}
                onChange={onChange}
                name="password"
                onKeyUp={onKeyUp}
              />
              {passwordShown === true ? (
                <AiOutlineEye
                  className="fs-5 cursor_pointer"
                  onClick={togglePassword}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="fs-5 cursor_pointer"
                  onClick={togglePassword}
                />
              )}
            </div>
          </div>

          {error.password && <p className="error">{error.password}</p>}

          <div className="mt-2">
            <Label className="mb-2">Confirm Password</Label>
            <div className="border_input rounded w-100 d-flex align-items-center">
              <Input
                className="fs-6 border-0 w-100 aaa"
                type={passwordShown2 ? "text" : "password"}
                onChange={onChange}
                name="confirmPassword"
                onKeyUp={onKeyUp}
              />
              {passwordShown2 === true ? (
                <AiOutlineEye
                  className="fs-5 cursor_pointer"
                  onClick={togglePassword2}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="fs-5 cursor_pointer"
                  onClick={togglePassword2}
                />
              )}
            </div>
          </div>

          {error.confirmPassword && (
            <p className="error">{error.confirmPassword}</p>
          )}
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Button className="btn_add w-50" onClick={onClick}>
            Save
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ModalAdd;
